import { ExternalLink, Upload } from "lucide-react";
import PropTypes from "prop-types";
import LoadingButton from "@components/ui-components/loading-button";
import { DISABLED_REASON, UPLOAD_LABEL } from "../misc/constants";

// The earnings row's tax invoice controls. A paid invoice is closed — its
// document stays readable but can no longer be changed — so on those rows the
// upload button is not rendered at all rather than shown disabled.
const InvoiceActionCell = ({ row, uploading, onUpload }) => {
    const { document, isPaid, invoiceId } = row;

    if (isPaid && !document) return <span className="text-muted">—</span>;

    return (
        <div className="flex items-center justify-end gap-2">
            {document && (
                <LoadingButton
                    color="neutral"
                    size="xs"
                    icon={ExternalLink}
                    text={UPLOAD_LABEL.VIEW}
                    href={document.url}
                    target="_blank"
                    tooltip={document.name}
                    testId="view-tax-invoice" />
            )}

            {!isPaid && (
                <LoadingButton
                    color="dark"
                    size="xs"
                    icon={Upload}
                    text={document ? UPLOAD_LABEL.REPLACE : UPLOAD_LABEL.UPLOAD}
                    loadingText="Uploading…"
                    loading={uploading}
                    disabled={!invoiceId}
                    tooltip={invoiceId ? "" : DISABLED_REASON.MISSING}
                    onClick={() => onUpload(row)}
                    testId="upload-tax-invoice" />
            )}
        </div>
    );
};

InvoiceActionCell.propTypes = {
    row: PropTypes.shape({
        invoiceId: PropTypes.string,
        isPaid   : PropTypes.bool,
        document : PropTypes.shape({
            url : PropTypes.string,
            name: PropTypes.string
        })
    }).isRequired,
    uploading: PropTypes.bool,
    onUpload : PropTypes.func.isRequired
};

export default InvoiceActionCell;
